import React from 'react';
import { getBase64, uploadImage } from './ImageUploader.utils';
import DummyImageUploader from './DummyImageUploader';
import { resizeImageTo1080pPreservingFormat } from '../../../Questionnaires/QuestionnairePage/components/QuestionViewerEditor/QuestionEditor/components/ImageEditor/utils';

type Props = {
  title: string;
  url: string | null;
  onChange: (base64: string) => void;
  className?: string;
  helperText?: string | null;
  accept?: string;
  onRemove?: () => void;
};

const ImageUploader = ({ title, url, className, helperText, accept, onRemove, onChange }: Props) => {
  const handleClick = async () => {
    const image = await uploadImage(accept);
    const resizedImage = await resizeImageTo1080pPreservingFormat(image);

    if (resizedImage) {
      const base64 = await getBase64(resizedImage);
      onChange(base64);
    }
  };

  return (
    <DummyImageUploader
      className={className}
      helperText={helperText}
      title={title}
      url={url}
      onChangeClick={handleClick}
      onRemove={onRemove}
    />
  );
};

export default ImageUploader;
